import clsx from "clsx";
import { graphql } from "gatsby";
import React, { FC } from "react";

import { CommonColors } from "../../../types/colors";
import {
  AnimatedSlider,
  AnimatedSliderItemData,
  AnimatedSliderLayout,
  AnimatedSliderVariant,
} from "../../sliders/animated-slider";
import { colorScheme } from "../../sliders/animated-slider/color-scheme";

export interface AnimatedSliderSectionProps extends Queries.AnimatedSliderSectionDataFragment {}

export const AnimatedSliderSection: FC<AnimatedSliderSectionProps> = ({
  slides,
  title,
  description,
  headerLayout,
  cta,
  maxVisibleCards,
  variant: _variant,
  initialAnimation,
  logo,
}) => {
  const variant = (_variant as AnimatedSliderVariant) ?? CommonColors.Neutral;
  return (
    <div className={clsx("pt-10", colorScheme[variant].containerClassName)}>
      <AnimatedSlider
        initialAnimation={initialAnimation ?? undefined}
        variant={variant}
        title={title ?? ""}
        logo={logo}
        description={description?.text ?? ""}
        headerLayout={headerLayout as AnimatedSliderLayout}
        cta={cta}
        maxVisibleCards={maxVisibleCards}
        items={(slides ?? []).filter(Boolean) as AnimatedSliderItemData[]}
      />
    </div>
  );
};

export const query = graphql`
  fragment AnimatedSliderSectionData on ContentfulAnimatedSliderSection {
    variant
    initialAnimation
    logo {
      ...ContentfulFixedImageData
    }
    title
    description {
      text: description
    }
    headerLayout
    maxVisibleCards
    slides {
      ... on ContentfulFlatCard {
        ...FlatCardData
      }
      ... on ContentfulImageCard {
        ...ImageCardData
      }
      ... on ContentfulMaterialCard {
        ...MaterialCardData
      }
      ... on ContentfulAppendixCard {
        ...AppendixCardData
      }
      ... on ContentfulProduct {
        __typename
        ...ProductData
      }
      ... on ContentfulWhatsNext {
        __typename
        ...WhatsNextData
      }
    }
    cta {
      ...CtaData
    }
  }
`;
